
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

@Component({})
export default class TextAreaExpand extends Vue {
	$refs!: {
		textarea: any;
	}

	@Prop({ type: String, default: "" })
	public value!: string;

	@Prop({ type: Number, default: 1 })
	public minRows!: number;

	@Prop({ type: String, default: "" })
	public placeholder!: string;

	@Prop({ type: Boolean, default: false })
	public readonly!: boolean;

	@Prop({ type: Boolean, default: true })
	public state!: boolean;

	heightWait: NodeJS.Timeout | null = null

	public get textarea (): any {
		return this.$refs.textarea
	}

	public mounted () {
		if (this.value) {
			this.expand()
		}
	}

	@Watch("value")
	public onValueChanged () {
		this.expand()
	}

	public get scrollHeight () {
		return this.textarea.scrollHeight
	}

	public beforeDestroy () {
		if (this.heightWait) {
			clearTimeout(this.heightWait)
			this.heightWait = null
		}
	}

	public expand (): void {
		this.textarea.rows = this.minRows
		Vue.nextTick().then(() => {
			if (this.textarea.scrollHeight === 0) {
				this.heightWait = setTimeout(() => {
					this.expand()
				}, 400)
			} else {
				this.textarea.rows = Math.max(this.minRows, Math.ceil(this.textarea.scrollHeight / 19.5))
				this.textarea.height = this.scrollHeight + "px"
			}
		})
	}
}
